import { Seo } from "../components/Seo";
import { Header } from "../components/Header";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <Seo title={"Contact PhudG | ASAFU Consumer Goods"} description={"Questions about our cold-pressed oils, bulk orders or retail partnerships — write to us and we will get back to you shortly."} path="/contact" />
      <Header />
      <div className="pt-16 bg-cream">
        <Contact />
      </div>
      <Footer />
    </main>
  );
}
